var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPricetag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5605 8.4395C11.1465 9.0245 11.1465 9.9755 10.5605 10.5605C9.97449 11.1465 9.02549 11.1465 8.43949 10.5605C7.85349 9.9755 7.85349 9.0245 8.43949 8.4395C9.02549 7.8535 9.97449 7.8535 10.5605 8.4395ZM5.83399 12.8916L11.866 18.9246L18.924 11.8666L12.892 5.83361L5.10699 5.1076L5.83399 12.8916ZM11.866 20.9986C11.401 20.9986 10.937 20.8216 10.582 20.4686L4.16499 14.0506C3.99999 13.8866 3.89799 13.6686 3.87599 13.4366L3.00399 4.0926C2.97699 3.7966 3.08199 3.50361 3.29299 3.2926C3.50399 3.0816 3.79599 2.9746 4.09299 3.0046L13.437 3.8766C13.669 3.89761 13.886 3.99961 14.051 4.16461L20.468 10.5816C20.811 10.9246 21 11.3806 21 11.8666C21 12.3526 20.811 12.8086 20.468 13.1516L13.151 20.4676C12.797 20.8216 12.332 20.9986 11.866 20.9986Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricetag);
export default __webpack_public_path__ + "static/media/pricetag.a464c91cdaab068e4d331a67c64e1ab8.svg";
export { ForwardRef as ReactComponent };